import React, {useState} from 'react';

import {InputNumber} from '@kit';

import type {Ability} from '../../../../../generated/types';
import {useCharacter} from '../../character-context';
import {ABILITIES} from '../../model/abilities';
import {MANUAL_MAX, MANUAL_MIN} from '../../model/ability-generation';
import {abilityLabel} from '../../model/labels';
import {AbilityRow} from './ability-row';

import css from '../master.module.css';

/** ручной набор: значения вводятся как есть, пустое поле не подменяется минимумом */
export const ManualScores: React.FC = () => {
	const {state, update} = useCharacter();
	const [cleared, setCleared] = useState<Ability[]>([]);

	const setScore = (ability: Ability, score: number | null) => {
		setCleared((abilities) =>
			score === null ? [...abilities, ability] : abilities.filter((other) => other !== ability),
		);
		if (score !== null) update((current) => ({baseAbilities: {...current.baseAbilities, [ability]: score}}));
	};

	return (
		<div className={css.abilityInputs}>
			{ABILITIES.map((ability) => (
				<AbilityRow key={ability} ability={ability} isEmpty={cleared.includes(ability)}>
					<InputNumber
						label={abilityLabel(ability)}
						min={MANUAL_MIN}
						max={MANUAL_MAX}
						value={cleared.includes(ability) ? null : state.baseAbilities[ability]}
						onChange={(score) => setScore(ability, score)}
					/>
				</AbilityRow>
			))}
		</div>
	);
};
